module.exports = __webpack_public_path__ + "static/img/not-submitted.614e0b81.png";